import { CoreTooltip } from '@featuring-corp/components';
import { IconInformationFilled } from '@featuring-corp/icons';
import { vars } from '@styles/vanilla-extract/theme.css';
import { flex } from '@styles/vanilla-extract/utils';
import React, { ReactNode } from 'react';

import { headerClass, headingTextClass, sectionClass } from './style.css';

export interface ReportSubSectionProps {
	title?: ReactNode;
	tooltip?: ReactNode;
	titleContent?: ReactNode;
	children?: ReactNode | ReactNode[];
}

const ReportSubSection = ({
	title,
	tooltip,
	titleContent,
	children,
}: ReportSubSectionProps) => {
	return (
		<section className={sectionClass}>
			<div className={headerClass}>
				<div className={flex({ gap: 'spacing-200' })}>
					<h3 className={headingTextClass}>{title}</h3>
					{tooltip && (
						<CoreTooltip text={tooltip} placement="top" autoAdjust zIndex={10000}>
							<IconInformationFilled
								size="16px"
								fill={vars.semantic.color.icon.tertiary}
							/>
						</CoreTooltip>
					)}
				</div>
				{titleContent ?? null}
			</div>

			{children}
		</section>
	);
};

export default ReportSubSection;
